import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Plus, Edit, Trash2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import PackageFormDialog from './PackageFormDialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PointPackagesTab = ({ packages, services, onRefresh }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  const handleOpen = (pkg = null) => {
    setEditingProduct(pkg);
    setDialogOpen(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Produkt wirklich löschen?')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/point-packages/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Punkt-Paket gelöscht');
      onRefresh();
    } catch (error) {
      toast.error('Fehler beim Löschen');
    }
  };

  const getServiceNames = (serviceIds) => {
    if (!serviceIds || serviceIds.length === 0) {
      return <Badge variant="outline" className="bg-green-50 text-green-700">Alle Services</Badge>;
    }
    return serviceIds.map(id => {
      const service = services.find(s => s.id === id);
      return service ? <Badge key={id} className="mr-1">{service.name}</Badge> : null;
    });
  };

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle data-testid="point-packages-title">Punkt-Pakete ({packages.length})</CardTitle>
          <Button onClick={() => handleOpen(null)} data-testid="add-point-package-btn">
            <Plus className="w-4 h-4 mr-2" />
            Neues Paket
          </Button>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Punkte</TableHead>
                <TableHead>Preis</TableHead>
                <TableHead>Erlaubte Services</TableHead>
                <TableHead>Aktiv</TableHead>
                <TableHead className="text-right">Aktionen</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {packages.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} className="text-center text-gray-500 py-8">
                    Noch keine Punkt-Pakete erstellt
                  </TableCell>
                </TableRow>
              ) : (
                packages.map((pkg) => (
                  <TableRow key={pkg.id} data-testid={`point-package-row-${pkg.id}`}>
                    <TableCell className="font-medium">{pkg.name}</TableCell>
                    <TableCell>{pkg.points_amount} Punkte</TableCell>
                    <TableCell>CHF {(pkg.price || 0).toFixed(2)}</TableCell>
                    <TableCell>{getServiceNames(pkg.allowed_service_ids)}</TableCell>
                    <TableCell>
                      <Badge variant={pkg.is_active ? 'default' : 'secondary'}>
                        {pkg.is_active ? 'Ja' : 'Nein'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex gap-2 justify-end">
                        <Button size="sm" variant="outline" onClick={() => handleOpen(pkg)}>
                          <Edit className="w-4 h-4" />
                        </Button>
                        <Button size="sm" variant="outline" onClick={() => handleDelete(pkg.id)}>
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <PackageFormDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        editingProduct={editingProduct}
        productType="points"
        services={services}
        onSaved={() => { setDialogOpen(false); onRefresh(); }}
      />
    </>
  );
};

export default PointPackagesTab;
